import type { RouteObject } from "../types";

export const routes = {
  en: {
    about: "about",
    contact: "contact",
    destinations: "destinations",
    experience: "experience",
  },
  fr: {
    about: "about",
    contact: "contact",
    destinations: "destinations",
    experience: "experience",
  }
} as RouteObject;
